<template>
  <Card class="moreInfo">
    <el-tabs v-model="curIndex" @tab-click="handleTabClick">
      <el-tab-pane name="medicalRecord" label="就诊记录">
        <medical-record v-if="show" :info="info" :appointList="appointList" :appoint="appoint" :dataSource="medicalRecord" @saveAppoint="getAppoint" @save="getPatientRecord" />
      </el-tab-pane>
      <el-tab-pane
        v-for="item in list"
        :key="item.id"
        :name="item.id + ''"
        :label="item.name"
      >
        <more-info-wrap style="padding: 16px;" :ref="'module' + item.id" v-if="item.type === '业务' && item.businesses && item.businesses.length" :info="info" :bus="item.businesses[0]" @save="saveAppoint"/>
        <more-info-module style="padding: 16px;" :ref="'module' + item.id" v-if="item.type === '目录'" :dataSource="item.child_modules" :info="info" @changeIndex="changeIndex($event, item.id)"/>
      </el-tab-pane>
      <el-tab-pane name="medicalTreat" label="管理方案">
        <treat-info ref="treatInfo" :info="info"></treat-info>
      </el-tab-pane>
      <el-tab-pane name="medicalEvent" label="活动记录">
        <event-info ref="eventInfo" :info="info"></event-info>
      </el-tab-pane>
    </el-tabs>
  </Card>
</template>
<script>
import {
  getPatientMedicalRecordApi,
  getPatientModuleListApi,
  getQuestionPatientRecordApi,
} from '../../../api/config'
import caringTitle from '../../../components/caring-title';
import treatInfo from "../components/treatInfo.vue";
import moreInfoWrap from '../components/moreInfoWrap.vue';
import moreInfoModule from "../components/moreInfoModule.vue";
import medicalRecord from '../components/medicalRecord.vue';
import eventInfo from "../components/eventInfo.vue" ;
export default {
  components: {
    caringTitle,
    treatInfo,
    eventInfo,
    moreInfoModule,
    moreInfoWrap,
    medicalRecord,
  },
  provide: {
    moreInfoType: 'medical'
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      height: '',
      list: [],
      curIndex: 'medicalRecord',
      medicalRecord: [],
      show: false,
      appointList: [],
      appoint: {}
    }
  },
  mounted() {
    this.height = window.innerHeight - 250;
    this.getPatientRecord();
    this.getModuleList();
  },
  methods: {
    getTreatInfo() {
      this.$refs.treatInfo.getTreatList();
    },
    changeIndex({p, c}, moduleId) {
      const module = this.list.find(l => l.id === moduleId);
      this.$set(module.child_modules[p], 'curIndex', c);
    },
    getPatientRecord() {
      getPatientMedicalRecordApi({ patient_id: this.info.patient_id }).then(
        (res) => {
          if (res.code === 0) {
            this.medicalRecord = res.data;
            this.$store.commit("setMedicalList", res.data)
            this.show = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      )
    },
    getModuleList() {
      getPatientModuleListApi(this.info.patient_id, 1).then((res) => {
        if (res.code === 0) {
          this.list = (res.data.default_module || []).map(d => {
            (d.child_modules || []).forEach(c => c.curIndex = 0)
            return d;
          });
          this.list.forEach(l => {
            (l.businesses || []).forEach(b => {
              if (b.code === "appointment") {
                const { patient_id } = this.info;
                this.appoint = b;
                getQuestionPatientRecordApi({
                  patient_id,
                  questionnaire_id: b.bind_code,
                }).then((res) => {
                  if (res.code === 0) {
                    this.appointList = res.data
                  }
                });
              }
            })
          })
          // this.getQuestionRecordList()
        }
      })
    },
    handleTabClick() {
      if (this.curIndex === 'medicalRecord') {
        this.getPatientRecord();
      } else if (this.curIndex === 'medicalTreat') {
        this.$nextTick(() => {
          this.$refs.treatInfo.getTreatList();
          this.$refs.treatInfo.calcWidth();
        })
      } else if (this.curIndex === 'medicalEvent') {
          this.$refs.eventInfo.getUserLog();
      } else {
        this.$refs['module' + this.curIndex][0].getList();
        // this.$refs['module' + this.curIndex][0].getTrend();
      }
    },
    // getQuestionRecordList() {
    //   if (this.curIndex === 'medicalRecord' || this.curIndex === 'medicalTreat') return
    //   const { patient_id } = this.info
    //   const module = this.list.find((l) => l.id == this.curIndex)
    //   let bus
    //   if (module.businesses) {
    //     bus = module.businesses.find((b) => b.id == module.curIndex)
    //   }
    //   if (bus) {
    //     getQuestionPatientRecordApi({
    //       patient_id,
    //       questionnaire_id: bus.bind_code,
    //     }).then((res) => {
    //       if (res.code === 0) {
    //         bus.list = res.data;
    //         if (bus.code === 'appoint') {
    //           this.appointList = res.data;
    //         }
    //       }
    //     });
    //   }
    // },
    saveAppoint(data) {
      this.appointList = data;
    },
    getAppoint() {
      const { patient_id } = this.info;
      getQuestionPatientRecordApi({
        patient_id,
        questionnaire_id: this.appoint.bind_code,
      }).then((res) => {
        if (res.code === 0) {
          this.appointList = res.data
        }
      });
    },
    addBusiness(bus, index) {
      this.$forceUpdate()
      this.$set(bus, 'curIndex', index)
    },
  },
}
</script>
